import { ColorPalette } from "../types/background";

// TODO: - remove this and use font and bg color helpers
// Left here fore now to make mocking easier
export const getColorClasses = (backgroundColor?: ColorPalette) => {
  switch (backgroundColor) {
    case "white":
      return "bg-white text-primary";
    case "primaryBlue":
      return "bg-primaryBlue text-white";
    case "primaryTurquoise":
      return "bg-primaryTurquoise text-primary";
    case "secondaryYellow":
      return "bg-secondaryYellow text-primary";
    case "secondaryDarkGreen":
      return "bg-secondaryDarkGreen text-white";
    case "secondaryGreen":
      return "bg-secondaryGreen text-primary";
    case "secondaryLightGreen":
      return "bg-secondaryLightGreen text-primary";
    case "neutral80":
      return "bg-neutral80 text-white";
    case "neutral60":
      return "bg-neutral60 text-white";
    case "neutral40":
      return "bg-neutral40 text-white";
    case "neutral10":
      return "bg-neutral10 text-primary";
    case "neutralYellow":
      return "bg-neutralYellow text-primary";
    case "transparent":
      return "bg-transparent text-primary";
    default:
      return "bg-primary text-white";
  }
};

export const getTextColorClass = (backgroundColor?: ColorPalette) => {
  switch (backgroundColor) {
    case "white":
    case "primaryTurquoise":
    case "secondaryYellow":
    case "secondaryGreen":
    case "secondaryLightGreen":
    case "neutral10":
    case "neutralYellow":
      return "text-primary";
    case "neutral80":
    case "neutral60":
    case "neutral40":
    default:
      return "text-white";
  }
};

export const getBackgroundColorClass = (backgroundColor?: ColorPalette) => {
  switch (backgroundColor) {
    case "primary":
      return "bg-primary";
    case "primaryBlue":
      return "bg-primaryBlue";
    case "primaryTurquoise":
      return "bg-primaryTurquoise";
    case "secondaryYellow":
      return "bg-secondaryYellow";
    case "secondaryLightGreen":
      return "bg-secondaryLightGreen";
    case "secondaryDarkGreen":
      return "bg-secondaryDarkGreen";
    case "secondaryGreen":
      return "bg-secondaryGreen";
    case "neutral80":
      return "bg-neutral80";
    case "neutral60":
      return "bg-neutral60";
    case "neutral40":
      return "bg-neutral40";
    case "neutral10":
      return "bg-neutral10";
    case "neutralYellow":
      return "bg-neutralYellow";
    case "white":
    default:
      return "bg-white";
  }
};

export const getFontColorClass = (fontColor?: ColorPalette) => {
  switch (fontColor) {
    case "primaryBlue":
      return "text-primaryBlue";
    case "primaryTurquoise":
      return "text-primaryTurquoise";
    case "secondaryYellow":
      return "text-secondaryYellow";
    case "secondaryLightGreen":
      return "text-secondaryLightGreen";
    case "secondaryDarkGreen":
      return "text-secondaryDarkGreen";
    case "secondaryGreen":
      return "text-secondaryGreen";
    case "white":
      return "text-white";
    case "neutral80":
      return "text-neutral80";
    case "neutral60":
      return "text-neutral60";
    case "neutral40":
      return "text-neutral40";
    case "neutral10":
      return "text-neutral10";
    case "neutralYellow":
      return "text-neutralYellow";
    default:
    case "primary":
      return "text-primary";
  }
};
